module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-left-5353968793bbf2d1e202d03102b906bc.svg";